import { functions } from '../firebaseConfig';
import { httpsCallable } from 'firebase/functions';

// Centralized function to call OpenAI through Firebase Functions
const callOpenAI = async (action, payload) => {
  const callOpenAIFunction = httpsCallable(functions, 'callOpenAI');
  const result = await callOpenAIFunction({ action, payload });
  return result.data;
};

export const analyzeProposal = async (template, generatedProposal, projectDescription) => {
  try {
    console.log('Analyzing proposal with AI assistant...');
    
    const result = await callOpenAI('analyzeProposal', {
      template,
      generatedProposal,
      projectDescription
    });

    return result.recommendations || [];
  } catch (error) {
    console.error('Error analyzing proposal:', error);
    return [];
  }
};

export const highlightChanges = async (template, generatedProposal) => {
  try {
    console.log('Highlighting changes in proposal...');
    
    const result = await callOpenAI('highlightChanges', {
      template,
      generatedProposal
    });

    return result.segments || [];
  } catch (error) {
    console.error('Error highlighting changes:', error);
    return [];
  }
};

export const analyzeTaskList = async (tasks, rawInput) => {
  try {
    console.log('Analyzing task list with AI assistant...');
    
    const result = await callOpenAI('analyzeTaskList', {
      tasks,
      rawInput
    });

    return result.suggestions || [];
  } catch (error) {
    console.error('Error analyzing task list:', error);
    return [];
  }
};
